var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',_vm._g(_vm._b({staticClass:"x-dropdown",attrs:{"items":_vm.items,"label":_vm.label,"item-text":"name","items-value":"id","outlined":"","single-line":"","append-icon":"keyboard_arrow_down","hide-details":"","solo":"","return-object":""}},'v-select',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }